<template>
    <div>
        <!-- 指派 -->
        <el-form ref="form" :model="form" label-width="80px" class="event-form">
            <el-row>
                <el-form-item label="下一节点" v-if="type!='transfer'&&type!='fail'&&type!='finish-observer'&&type!='reject'&&type!='cancel'&&type!='rebut'">
                    <el-input v-model="this.form.handle" disabled></el-input>
                </el-form-item>
            </el-row>
            <el-row>
            <!--处理组-->
                <el-col :span="12">
                    <el-form-item :label="type=='cab-audit'?'CAB处理组':'处理组'" v-if="type!='fail'&&type!='finish-observer'&&type!='reject'&&type!='cancel'&&type!='rebut'&&type!='cab-rejected'">
                        <el-select v-model="form.currentDepartment" filterable placeholder="请选择" @change="departmentChange">
                            <el-option v-for="item in departmentList" :key="item.index" :label="item.name"
                                       :value="item.id"></el-option>
                        </el-select>
                        <el-button :type="groupTasksTotal>=5?'danger':'success'" plain  >组繁忙度  ({{groupTasksTotal}})</el-button>
                    </el-form-item>
                </el-col>
            <!--处理人-->
                <el-col :span="12">
                    <el-form-item label="处理人" v-if="type!='fail'&&type!='finish-observer'&&type!='reject'&&type!='cancel'&&type!='rebut'&&type!='cab-rejected'">
                        <div class="el-form__inline">
                            <el-input v-model="form.currentHandlerName" disabled></el-input>
                            <el-button  type="primary" class="iconfont icon-gengduo icon" :disabled="dis_user" @click="toRequesterList"></el-button>
                            <el-button type="primary" :type="userTasksTotal>=5?'danger':'success'" plain >人员繁忙度  ({{userTasksTotal}})</el-button>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row v-if="type=='solution'">
                <!--高危操作-->
                <el-col :span="24">
                    <el-form-item label="高危操作" prop="isHighRiskOperation">
                        <el-radio v-model="form.isHighRiskOperation" label="1">是</el-radio>
                        <el-radio v-model="form.isHighRiskOperation" label="0">否</el-radio>
                    </el-form-item>
                </el-col>
            </el-row>
            <!--完成程度-->
            <el-form-item prop="completionDegree" label="完成程度" v-if="type=='complete'">
                <el-select v-model="form.completionDegree" placeholder="请选择">
                    <el-option v-for="item in completionDegree" :key="item.id" :label="item.cname"
                               :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <!--处理意见-->
            <el-form-item label="处理意见" v-if="implementCompleted===false">
                <el-input type="textarea" v-model="form.handleComment"></el-input>
            </el-form-item>
            <!--知会-->
            <el-form-item label="知会" >
                <div class="el-form__inline">
                    <notifyTab :data="form.notify" :getData="getNotifyData"></notifyTab>
                    <router-link :to="{ path:'/requesterList',query: { callback:getNoticer,moreSelect:true } }">
                        <span  class="noticeAdd">+</span>
                    </router-link>
                </div>
            </el-form-item>

            <!--解决方案-->
            <el-row>
                <el-col :span="24">
                    <el-form-item label="解决方案" v-if="implementCompleted===true">
                        <ueditor v-model="solutionComment" :config="myConfig" :key="1" :value="2" @ready="editorReady"></ueditor>
                        <div>
                            <el-checkbox v-model="upKnowledge">解决方案保存到知识库</el-checkbox>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>

            <!--知识分类-->
            <el-row v-if="upKnowledge">
                <el-col :span="12" v-if="implementCompleted===true">
                    <el-form-item label="知识分类">
                        <el-select v-model="knowledgeClass" placeholder="请选择">
                            <el-option v-for="item in categoryList" :key="item.id" :label="item.title"
                                       :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12" v-if="implementCompleted===true">
                    <el-form-item label="知识关键字">
                        <el-input v-model="knowledgeKeyword"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="附件" v-if="type=='solution'">
                            <inputFile :data="attachment" :getFiles="getFiles"></inputFile>
                        </el-form-item>
                    </el-col>
                </el-row>

            <el-form-item>
                <el-button type="primary" @click="submit" :disabled="isSubmit">确定</el-button>
                <el-button type="default" @click="onCancel">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    // import departmentFrame from "../../components/departmentFrame.vue";
    import services from "../../services/common.service"
    import notifyTab from "../common/notifyTab.vue"
    const VueUeditorWrap = window.VueUeditorWrap;
    import Config from "../../app.config";
    import ueditor from "../../components/ueditor.vue"
    import inputFile from "../common/inputFile.vue"
    import commonService from "../../services/common.service"
    export default {
        props:{
            serialNumber:String,
            callback:Function,
            type:{
                type:String,
                default:""
            },
            changeType:String,
            status:String,
            currentHandler:String,  //当前处理人，用于cab审批通过时选择处理人时排除自己
        },
        data() {
            return {
                form:{
                    currentDepartment:"",
                    designator:'',
                    handle:"",
                    currentHandlerName:'',
                    currentHandlerId:'',
                    handleComment:'',
                    attachment:'',
                    isHighRiskOperation: "0",
                    notify:[]
                },
                notifyUserid:[],
                solutionComment:"",
                upKnowledge:false,
                knowledgeClass:"",
                knowledgeKeyword:"",
                departmentList:[],      // 处理组
                implementCompleted:false,
                dis_user:true,
                attachment:[],        //上传附件
                categoryList:[],
                groupTasksTotal:'',   //组任务数
                userTasksTotal:'',    //人员任务数量
                isSubmit:false,
                noDepartment:false,  //控制点击‘变更完成’ 和‘变更失败’时可不选处理组直接提交
                exceptMe:false,   //在CAB审批通过时不能选择自己(当前处理人)
                myConfig: {
                    autoHeightEnabled: false,
                    initialFrameHeight: 200,
                    initialFrameWidth: '100%',
                    UEDITOR_HOME_URL: '/UEditor/',
                    serverUrl:Config.BASE_API + "upload/",
                },
            }
        },
        components:{ ueditor ,notifyTab,inputFile},
        created() {
            this.getDepartment();
            this.getUserId()
            this.getCategoryList();

            if(this.type == "solution"){
                this.implementCompleted=true
                this.form.handle = "实施解决方案"
                this.$modal.title = '制定解决方案';

            };
            if(this.type == "cab-rejected"){
                this.form.handle = "服务台"
                this.$modal.title = 'CAB审批不通过';
            };
            if(this.type == "cab-approved"){
                this.form.handle = "CAB评审"
                this.$modal.title = 'CAB审核通过';
                this.exceptMe=true
            };
            if(this.type == "all-approved"){
                this.form.handle = "制定解决方案"
                this.$modal.title = 'CAB全部通过';
            };

            if(this.type == "accept"){
                this.form.handle = "CAB审批/制定解决方案"
                this.$modal.title = '变更工单接收';
            };
            // if (this.type == "review-and-close"){
            //     this.$modal.title = "回顾并关闭"
            // }
            if (this.type == "complete"){
                this.$modal.title = "变更完成"
                this.form.handle='观察中'
            }
            if (this.type == "fail"){
                this.$modal.title = "变更失败"
            }
            if(this.type=='reject'){
                this.$modal.title='拒绝'
            }
            if(this.type=='cancel'){
                this.$modal.title='取消'
            }

            if (this.type == 'finish-observer') {
                this.$modal.title = "观察完成"
            }
            if (this.type == "transfer"){
                this.$modal.title = "转交"
            }

        },
        computed:{
            dictionary(){
                return this.$store.state.dictionary;
            },
            waitApprove(){
                return this.$store.state.waitApprove;
            },
            // 知识分类id
            knowledgeType(){
                return this.$store.state.caseType.knowledge;
            },
            completionDegree(){
                return this.dictionary.completion_degree
            }
        },
        methods: {
            getUserId(){
                this.form.designator=localStorage.getItem('internalUserid')
            },
            // 获取知识分类
            getCategoryList(){
                commonService.categoryList(this.knowledgeType.id).then(res => {
                    this.categoryList = res;
                })
            },
            // 编辑器获取内容
            // getUeContent(val){
            //     this.solutionComment = val;
            // },
            editorReady (editorInstance) {
                editorInstance.setContent('你可以在这里初始化编辑器的初始内容。');
                let _this = this
                editorInstance.addListener('contentChange', () => {
                  // console.log('编辑器内容发生了变化:', editorInstance.getContent());getContentTxt()
                  // _this.form.Body = editorInstance.getContent()
                   _this.solutionComment = editorInstance.getContent()
                });
            },
            // 服务组
            getDepartment(){
                // console.log(this.waitApprove)
                // console.log(this.status);
                let params= {
                    departmentId:this.type == "cab-approved"&&this.changeType!='199'?99998:99999,
                    // id:99999,
                    type:'group'
                }
                //9999是服务组，9998是CAB小组
                //199时跳过CAB，永远9999，非199时，在工单接受处时9999，
                if (this.changeType!='199'&&this.type=='accept'){
                    params.departmentId=99998
                }
                if (this.type=='transfer'&&this.status=='CAB审批') {
                    // console.log(this.status);
                    params.departmentId=99998
                }
                services.getDepartmentList(params).then(res => {
                    this.departmentList = res.list;

                })

                if(this.waitApprove && JSON.stringify(this.waitApprove) !== '{}' &&  this.type != 'all-approved'){
                    // this.form.currentDepartment =this.waitApprove.group_info.group_id
                    this.form.currentDepartment =this.waitApprove['group_info']['group_id']
                    this.dis_user = false
                    // this.form.currentHandlerName =
                    this.getRequester({
                        name:this.waitApprove.user_info.user_name,
                        internalUserid:this.waitApprove.user_info.internal_userid

                    })
                    // this.form.currentDepartment = 19
                }else{
                    // this.form.currentDepartment = ""
                    // this.dis_user = true
                    console.log('meiyou waitapprove')
                }
            },
            departmentChange(){
                this.dis_user = this.form.currentDepartment ? false : true;
                let groupId=this.form.currentDepartment
                this.form.currentHandlerName = ''
                this.userTasksTotal=''
                this.getGroupBusyness(groupId)
            },
            getGroupBusyness(id){
                services.busynessGroup(id).then(res => {
                    this.groupTasksTotal = res.tasksTotal;
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
            submit(){
                // let params = {
                //     serialNumber:this.serialNumber,
                //     designator:this.form.designator,
                //     handle:this.type,
                //     currentDepartment:this.form.currentDepartment,
                //     currentHandler:this.form.currentHandlerId,
                //     handleComment:this.form.handleComment,
                //     solution:this.form.solution,
                //     attachment:this.attachment
                // }
                this.isSubmit=true
                let params=this.getParams()
                if (this.type=='fail'||this.type == 'finish-observer'||this.type=='reject'||this.type=='cancel'||this.type=='cab-rejected'){
                    this.noDepartment=true
                }
                if (!this.noDepartment&&!params.currentDepartment&&this.type!='rebut') {
                    this.isSubmit=false
                    this.$message.error('请选择处理组')
                }else if(this.type=='complete'&&!this.form.completionDegree){
                    this.isSubmit = false
                    this.$message.error('请选择完成程度')
                }else if(this.type!='fail'&&this.type!='finish-observer'&&this.type!='reject'&&this.type!='cancel'&&this.type!='rebut'&&this.type!='cab-rejected'&&!this.form.currentHandlerName){
                    this.isSubmit=false
                    this.$message.error('请选择处理人')
                }else if(this.implementCompleted===false&&!this.form.handleComment){
                    this.isSubmit=false
                    this.$message.error('请填写处理意见')
                }else if(this.implementCompleted===true&&!this.solutionComment){
                    this.isSubmit=false
                    this.$message.error('请填写解决方案')
                }else{
                    services.changeHandle(params).then(res => {
                        this.$message.success(this.$modal.title+"成功");
                        this.close(true);
                    }).catch(err => {
                        this.isSubmit=false
                        this.$message.error(err.message);
                    })
                }

            },
            getParams(){
                this.notifyUserid=this.form.notify&&this.form.notify.map(item=>{return item.userid})
                let upKnowledge = this.upKnowledge ? "1" : "0";
                let params = {
                    ...this.form,
                    handle:this.type,
                    designator:this.form.designator,
                    serialNumber:this.serialNumber,
                    handleComment:this.form.handleComment,
                    currentHandler:this.form.currentHandlerId,
                    solution:this.solutionComment,
                    upKnowledge:upKnowledge,
                    attachment:this.attachment,
                    notify:this.notifyUserid

                };
                if(this.upKnowledge){
                    params.knowledgeKeyword = this.knowledgeKeyword.split(",");
                    params.knowledgeClass = this.knowledgeClass;
                }
                return params;
            },
            //将选择的知会人信息去重保存
            getNoticer(obj){
                this.form.notify=this.arrayUnique(this.form.notify.concat(obj))
            },
            //删除后显示剩余的知会人
            getNotifyData(val){
                this.form.notify=val
            },
            //选择完知会人后去重，此方法可通用于包含对象的数组深层次去重
            arrayUnique(arr){
                let obj={}
                let newArr = []
                arr.forEach(item=>{
                    if(!obj[item.id]){
                        obj[item.id]=1
                        newArr.push(item)
                    }
                })
                return newArr
            },
            // 组员页面
            toRequesterList(){
                let id = this.form.currentDepartment;
                this.$router.push({
                    path: '/appointUser',
                    name: "appointUser",
                    query: {
                        callback:this.getRequester,
                        id:`${id}`,
                        exceptMe:this.exceptMe,
                        currentHandler:this.currentHandler
                    }
                })
            },

            getRequester(obj){
                this.form.currentHandlerName = obj.name;
                this.form.currentHandlerId = obj.internalUserid;
                let userid=this.form.currentHandlerId
                this.getUserBusyness(userid)
            },
            getUserBusyness(id){
                services.busynessUser(id).then(res => {
                    this.userTasksTotal= res.tasksTotal;
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
            //上传文件
            // fileChange(e){
            //     let files = e.target.files || e.dataTransfer.files;
            //     if (!files.length){
            //         return;
            //     };
            //     // this.form.attachment = files[0];
            //     let params = {
            //         file_name:files[0]
            //     };
            //     commonService.uploading(params).then(res => {
            //         let file =  res;
            //         this.attachment.push({
            //             name:file.file_name,
            //             url:file.download_url
            //         })
            //     }).catch( err => {
            //         this.$message.error(err.message);
            //     })
            // },
            //上传附件
            getFiles(val){
                this.attachment = val;
            },
            onCancel(){
                this.close();
            },
            close(refresh) {
                this.$modal.close();
                refresh && refresh === true ? this.callback() : '';
            }

        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
    .noticeAdd{
        color: #1890ff;
        font-size: 27px;
        position: relative;
        top: -2px;
        margin-left: 10px;
    }
</style>
